import script from "./MapLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapLegend.vue?vue&type=script&lang=ts&setup=true"

import "./MapLegend.vue?vue&type=style&index=0&id=9943da6c&lang=css"

const __exports__ = script;

export default __exports__